import { Moment } from 'moment';

export const toTime = (m: Moment): string => {
  return m.format('HH:mm:ss');
};
